import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-chessup-bg">
        <div className="h-10 w-10 rounded-full border-2 border-chessup-turq border-t-transparent animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/entrar" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/painel" replace />;
  return children;
}
